import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageWatermarkRemoverConfig } from '@/data/landingConfig/landingImageWatermarkRemoverConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageWatermarkRemover } from './schemaObject';

interface Props {}
const ImageWatermarkRemover: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageWatermarkRemover} />
			<LandingTemplate
				data={landingImageWatermarkRemoverConfig}
				funnelLinkService={GenerateLandingLinkService.funnelWatermarkRemoverV2()}
			/>
		</>
	);
};

export default ImageWatermarkRemover;
